import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import TranslationFields from './translationFields/TranslationFields';
import { renderCheckbox } from '../../utils/materialUiReduxForms';


class Form extends Component {
  constructor(props) {
    super(props);
  
    this.state = {
      localeItems: [],
      localesNumber: 0
    };
  }

  componentDidMount () {
    if (this.props.initialValues && this.props.initialValues.translations.length) {
      this.setState({
        localeItems: this.props.initialValues.translations,
        localesNumber: this.props.initialValues.translations.length
      }, () => this.props.change('translationsNumber', this.state.localesNumber));
      //init our form values
      let i = 1;
      this.props.initialValues.translations.forEach( v => {
        this.props.change('language' + i, v.locale);
        this.props.change('languageText' + i, v.content);
        this.props.change('updateTranslationId' + i, v['@id']);
        i++;
      });
      this.props.change('translationsNumber', this.state.localesNumber)
    }
  }

  handleDelete = (id) => {
    this.props.change('language' + id, null);
    this.setState({
      localeItems: this.state.localeItems.filter(l => l.id !== id)
    })
  }

  handleAddLocale = (id) => {
    this.setState({
      localesNumber: this.state.localesNumber + 1,
      localeItems: [
        ...this.state.localeItems,
        {
          id: this.state.localesNumber + 1,
        }
      ]
    }, () => this.props.change('translationsNumber', this.state.localesNumber))

  }

  renderField(data) {
    const hasError = data.meta.touched && !!data.meta.error;
    if (hasError) {
      data.input['aria-describedby'] = `productoption_${data.input.name}_helpBlock`;
      data.input['aria-invalid'] = true;
    }

    return <div className={`form-group${hasError ? ' has-error' : ''}`}>
      <label htmlFor={`productoption_${data.input.name}`} className="control-label">{data.input.name}</label>
      <input {...data.input} type={data.type} step={data.step} required={data.required} placeholder={data.placeholder} id={`productoption_${data.input.name}`} className="form-control"/>
      {hasError && <span className="help-block" id={`productoption_${data.input.name}_helpBlock`}>{data.meta.error}</span>}
    </div>;
  }

  render() {
    const { handleSubmit, initialValues } = this.props;
    const languages = initialValues ? initialValues.languages : [];

    return <form onSubmit={handleSubmit}>
      <Field component={this.renderField} name="name" type="text" placeholder="" />
      {languages.length > 0 ?
        <div>
          <label>Labels</label>
         {
          this.state.localeItems.map( (items, i) => {
             return (
               <TranslationFields
                 key={items.id}
                 translationNumber={i+1}
                 languages={languages}
                 onDelete={this.handleDelete}
                 id={items.id}
                 item={items}
               />
             )
           })
          }
        </div>
        : null
      }
     {languages.length > 0 ?
      <div>
         <i
           className="fa fa-plus-square plus-button"
           onClick={this.handleAddLocale}
         />
      </div>
       : null
     }

      <Field component={this.renderField} name="type" type="text" placeholder="" />
      <Field component={this.renderField} name="defaultValue" type="text" placeholder="" />
      {/* <Field component={this.renderField} name="createdAt" type="text" placeholder="" />
      <Field component={this.renderField} name="updatedAt" type="text" placeholder="" /> */}
      <Field component={this.renderField} name="product" type="text" placeholder="" />
      <Field label="is Wbs" component={ renderCheckbox } name="isWbs" type="checkbox" placeholder="" />

        <button type="submit" className="btn btn-primary">Submit</button>
      </form>;
  }
}

export default reduxForm({form: 'productoption', enableReinitialize: true, keepDirtyOnReinitialize: true})(Form);



// WEBPACK FOOTER //
// ./src/components/productoption/Form.js